export { default as TabHeaderDepartment } from './Department.tab';
export { default as TabHeaderTerm } from './Term.tab';
